module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<ul class="t-o-c-pop">\n  <li>\n    <label for="">费用包含</label>\n    <p>' +
((__t = ( payIn || '' )) == null ? '' : __t) +
'</p>\n  </li>\n  <li>\n    <label for="">票种说明</label>\n    <p><span>取票时间:</span>' +
((__t = ( pickTime || '' )) == null ? '' : __t) +
'</p>\n    <p><span>取票方法:</span>' +
((__t = ( pickMode || '' )) == null ? '' : __t) +
'</p>\n    <p><span>入园地址:</span>' +
((__t = ( pointAdress || '' )) == null ? '' : __t) +
'</p>\n    <p><span>门票有效说明:</span>' +
((__t = ( effectiveDesc || '' )) == null ? '' : __t) +
'</p>\n  </li>\n\n  <li>\n    <label for="">重要提示</label>\n    <p class="importantNotice"></p>\n  </li>\n</ul>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/js/ticketOrderConfirm/templates/orderNeedKnow.ejs
// module id = 58
// module chunks = 0 1 2 6 10 11 14